import { useRef as i, useEffect as a } from "react";
const f = [
  "a[href]",
  "button:not([disabled])",
  "input:not([disabled])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  '[tabindex]:not([tabindex="-1"])'
].join(", ");
function d(r) {
  const u = i(null);
  return a(() => {
    if (!r) return;
    const n = u.current;
    if (!n) return;
    const c = (e) => {
      if (e.key !== "Tab") return;
      const t = n.querySelectorAll(f);
      if (t.length === 0) return;
      const o = t[0], s = t[t.length - 1];
      if (e.shiftKey && document.activeElement === o) {
        e.preventDefault(), s.focus();
        return;
      }
      if (!e.shiftKey && document.activeElement === s) {
        e.preventDefault(), o.focus();
        return;
      }
      n.contains(document.activeElement) || (e.preventDefault(), o.focus());
    };
    return document.addEventListener("keydown", c), () => {
      document.removeEventListener("keydown", c);
    };
  }, [r]), u;
}
export {
  d as useFocusTrap
};
